import { AppService } from '../services/app.service';

export function AppServiceFactory(appService: AppService) {
  return () => appService.initApp();
}
